import { FC, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAccess } from "../../hooks/useAccess";
import { isCurrentPath } from "../../utils/isCurrentPath";
import { INavItem } from "./INav";

const HeaderNav: FC = () => {
  const { getPageAccess } = useAccess();
  const { pathname } = useLocation();
  
  const filterNav = (nav: INavItem[]): INavItem[] =>
    nav.reduce((acc, item) => {
      if (item?.isNotAvailable || !item?.name) return acc;
      if (!item?.children?.length) return [...acc, item];
      
      const children = filterNav(item.children);
      if (children?.length) return [
        ...acc,
        {
          ...item,
          children 
        }
      ];
      return acc;
    }, [] as INavItem[]);

  const nav: INavItem[] = filterNav([
      // { 
      //   name: 'Account',
      //   to: `/account`,
      //   isNotAvailable: !getPageAccess('/account'),
      // },
      { 
        name: 'Users',
        to: '/users',
        isNotAvailable: !getPageAccess('/users')
      },
      { 
        name: 'New User',
        to: '/users/new',
        isNotAvailable: !getPageAccess('/users/new'),
        isCurrent: pathname === '/users/new',
      },   
      {
        name: 'Roles',
        to: '/roles',
        isNotAvailable: !getPageAccess('/roles'),
        isCurrent: pathname === '/roles',
      },
      {
        name: 'Vendors',
        to: '/vendors',
        isNotAvailable: !getPageAccess('/vendors'),
        isCurrent: pathname === '/vendors',
      },
      {
        name: 'New Vendor',
        to: '/vendors/new',
        isNotAvailable: !getPageAccess('/vendors/new'),
        isCurrent: pathname === '/vendors/new',
      },
  ]);

  const isCalculatedCurrent = nav.find(({ isCurrent }) => isCurrent);

  const [openedNavsIndxs, setOpenedNavsIndxs] = useState<Record<string, boolean>>(nav.reduce((acc, { children }, i) => ({
    ...acc,
    [i]: !!children?.length
  }), {} as Record<string, boolean>)); 

  return (
    <nav className="flex h-full items-center">
      {!!nav?.length && nav
        .filter(({ isNotAvailable }) => !isNotAvailable)
        .map(({ name, to, onClick, isCurrent }, i) => to
            ? (
              <Link
                key={`header-nav-item-${i}`}
                to={to}
                className={`
                  h-full flex items-center px-8
                  text-md hover:text-primary_hover transition-all underline underline-offset-4 
                  relative border-b-[1px] top-[1px]
                  ${(isCalculatedCurrent ? isCurrent : isCurrentPath(pathname, to))
                    ? 'text-primary no-underline border-b-white font-semibold bg-gradient-to-b from-transparent to-white'
                    : ' border-b-transparent'}
                `}
              >
                {name}
              </Link>
            )
            : ''          
        )
      }
    </nav>
  );
}

export default HeaderNav;
